import { render, staticRenderFns } from "./ButtonConfirm.vue?vue&type=template&id=931a1986&scoped=true&"
import script from "./ButtonConfirm.vue?vue&type=script&lang=js&"
export * from "./ButtonConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ButtonConfirm.vue?vue&type=style&index=0&id=931a1986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931a1986",
  null
  
)

export default component.exports